/**
 * Curated stage maps. Every row is exactly GRID.cols (13) characters.
 *
 * Legend
 *   .  empty        w  white     o  orange    c  cyan      g  green
 *   r  red          b  blue      m  magenta   y  yellow
 *   S  silver (multi-hit)        G  gold (indestructible)
 */

export const LEVELS = [
  {
    name: 'Opening Salvo',
    rows: [
      'wwwwwwwwwwwww',
      'ooooooooooooo',
      'ccccccccccccc',
      'ggggggggggggg',
      'rrrrrrrrrrrrr',
      'bbbbbbbbbbbbb',
    ],
  },
  {
    name: 'Gatehouse',
    rows: [
      'G...........G',
      '.yyyyyyyyyyy.',
      '.y.........y.',
      '.y.mmmmmmm.y.',
      '.y.........y.',
      '.yyyyyyyyyyy.',
      'G...........G',
    ],
  },
  {
    name: 'Interlock',
    rows: [
      'c.c.c.c.c.c.c',
      '.m.m.m.m.m.m.',
      'c.c.c.c.c.c.c',
      '.m.m.m.m.m.m.',
      'c.c.c.c.c.c.c',
      '.m.m.m.m.m.m.',
      'S.S.S.S.S.S.S',
    ],
  },
  {
    name: 'Ziggurat',
    rows: [
      '......y......',
      '.....yyy.....',
      '....ooooo....',
      '...rrrrrrr...',
      '..ggggggggg..',
      '.bbbbbbbbbbb.',
      'ccccccccccccc',
      'G.G.G.G.G.G.G',
    ],
  },
  {
    name: 'The Vault',
    rows: [
      '..SSSSSSSSS..',
      '.S.........S.',
      'S...ooooo...S',
      'S..o.....o..S',
      'S..o.rrr.o..S',
      'S..o.....o..S',
      'S...ooooo...S',
      '.S.........S.',
      '..SSSSSSSSS..',
    ],
  },
  {
    name: 'Chevron',
    rows: [
      'r...........r',
      'rr.........rr',
      '.oo.......oo.',
      '..cc.....cc..',
      '...gg...gg...',
      '....bb.bb....',
      '.....mmm.....',
      'G...........G',
    ],
  },
  {
    name: 'Fortress',
    rows: [
      '.GGG.....GGG.',
      '.GwwwwwwwwwG.',
      '.Gw.......wG.',
      '.Gw.SSSSS.wG.',
      '.Gw.......wG.',
      '.GwwwwwwwwwG.',
      '.GGG.....GGG.',
    ],
  },
  {
    name: 'Downpour',
    rows: [
      'y.b.y.b.y.b.y',
      'y.b.y.b.y.b.y',
      'y.b.y.b.y.b.y',
      '.............',
      'S.S.S.S.S.S.S',
      '.............',
      'ccccccccccccc',
      'ooooooooooooo',
    ],
  },
  {
    name: 'Silver Maze',
    rows: [
      'SSSS.SSS.SSSS',
      '...g.....g...',
      '.ggg.ggg.ggg.',
      '...r.....r...',
      '.rrr.rrr.rrr.',
      '...m.....m...',
      '.mmm.mmm.mmm.',
      'G..G..G..G..G',
    ],
  },
  {
    name: 'Sentinel',
    rows: [
      '..ccccccccc..',
      '.ccccccccccc.',
      'cc.rr.c.rr.cc',
      'ccccccccccccc',
      'cc.wwwwwww.cc',
      'ccc.......ccc',
      '.SS.SSSSS.SS.',
      '..G.......G..',
    ],
  },
  {
    name: 'Gauntlet',
    rows: [
      'GSGSGSGSGSGSG',
      'mmmmmmmmmmmmm',
      '.y.y.y.y.y.y.',
      'rrrrrrrrrrrrr',
      '.b.b.b.b.b.b.',
      'ggggggggggggg',
      '.o.o.o.o.o.o.',
      'ccccccccccccc',
      'S.S.S.S.S.S.S',
    ],
  },
  {
    name: "DOH's Chamber",
    boss: true,
    rows: [
      'G...........G',
      '.SS.......SS.',
      '.............',
      '.............',
      '.............',
      '.............',
      '.SS.......SS.',
      'G...........G',
    ],
  },
];

export const TOTAL_ROUNDS = LEVELS.length;
